import {
  CefiInfoTx,
  DefiInfoTx,
  Order,
  OrderStatus,
  OrderType,
  PureTransaction,
  Transaction,
  TxStatus,
  WalletType,
} from "@cede/types";

export const pureTransactionMock: PureTransaction = {
  from: {
    transaction: {
      amount: 123,
      refAmount: 3303043.993275045,
      fee: {
        amount: 0.5,
        refAmount: 13427.008102744085,
        tokenSymbol: "BTC",
      },
      status: TxStatus.OK,
      timestamp: 1234,
      tokenSymbol: "BTC",
      transactionId: "1",
    },
    exchangeAccount: {
      exchangeId: "binance",
      exchangeInstanceId: "d09010bcf23344a5f04665e2ed00e0181bb00c7924e4ddc50a45b044a91bacd1",
    },
    wallet: {
      depositAddress: "unknown",
      walletType: WalletType.SPOT,
    },
  },
  to: {
    account: {
      address: "0x12d2332s3432221",
      network: "Polygon",
    },
    transaction: {
      fee: {
        amount: 0.5,
        refAmount: 13427.008102744085,
        tokenSymbol: "BTC",
      },
      status: TxStatus.OK,
      timestamp: 1234,
      tokens: [
        {
          address: "unknown",
          amount: 123,
          refAmount: 3303043.993275045,
          tokenSymbol: "BTC",
        },
      ],
      transactionHash: "1",
    },
  },
  type: "withdrawal",
};
export const fixtures = {
  DEFAULT_TX_ID: "transaction-id",
  DEFAULT_ORDER_STATUS: OrderStatus.CLOSED,
  DEFAULT_EXCHANGE_ID: "binance",
  DEFAULT_TX_SYMBOL: "USDT",
  DEFAULT_TX_AMOUNT: 1200,
  DEFAULT_TX_FEE: 1,
  DEFAULT_TX_FEE_SYMBOL: "USDT",
  DEFAULT_TX_TIMESTAMP: 1609459200000,
  DEFAULT_TX_STATUS: TxStatus.OK,
  DEFAULT_TX_ADDRESS: "0x1234",
  DEFAULT_TX_NETWORK: "ethereum",
  DEFAULT_TX_HASH: "unknown", // TODO to replace with 0xhash when we'll be able to retrieve it
  DEFAULT_TX_AMOUNT_2: 12,
  DEFAULT_TX_REF_AMOUNT: 45000,
  DEFAULT_TX_SYMBOL_2: "BTC",
  PAIR_SYMBOL: "BTC/USDT",
  PRICE: 100,
};

export const transactionMock: Transaction<CefiInfoTx, DefiInfoTx> = {
  from: {
    account: {
      exchangeId: fixtures.DEFAULT_EXCHANGE_ID,
      accountId: "binance-account-id",
    },
    wallet: {
      depositAddress: fixtures.DEFAULT_TX_ADDRESS,
      walletType: WalletType.SPOT,
    },
    transaction: {
      amount: fixtures.DEFAULT_TX_AMOUNT,
      tokenSymbol: fixtures.DEFAULT_TX_SYMBOL,
      transactionId: fixtures.DEFAULT_TX_ID,
      fee: {
        amount: fixtures.DEFAULT_TX_FEE,
        tokenSymbol: fixtures.DEFAULT_TX_FEE_SYMBOL,
      },
      status: fixtures.DEFAULT_TX_STATUS,
      timestamp: fixtures.DEFAULT_TX_TIMESTAMP,
    },
  },
  to: {
    account: {
      address: fixtures.DEFAULT_TX_ADDRESS,
      network: fixtures.DEFAULT_TX_NETWORK,
    },
    transaction: {
      transactionHash: fixtures.DEFAULT_TX_HASH,
      fee: {
        amount: fixtures.DEFAULT_TX_FEE,
        tokenSymbol: fixtures.DEFAULT_TX_FEE_SYMBOL,
      },
      status: fixtures.DEFAULT_TX_STATUS,
      timestamp: fixtures.DEFAULT_TX_TIMESTAMP,
      tokens: [
        {
          amount: fixtures.DEFAULT_TX_AMOUNT,
          tokenSymbol: fixtures.DEFAULT_TX_SYMBOL,
          address: fixtures.DEFAULT_TX_ADDRESS,
        },
      ],
    },
  },
  type: "deposit",
};

export const createMockedTrade = (
  exchangeId = fixtures.DEFAULT_EXCHANGE_ID,
  txid = fixtures.DEFAULT_TX_ID,
  txStatus = fixtures.DEFAULT_TX_STATUS,
): Transaction<CefiInfoTx, CefiInfoTx> => ({
  pairSymbol: fixtures.PAIR_SYMBOL,
  from: {
    account: {
      accountId: `${exchangeId}-1`,
      exchangeId,
    },
    transaction: {
      amount: fixtures.DEFAULT_TX_AMOUNT,
      fee: {
        amount: fixtures.DEFAULT_TX_FEE,
        tokenSymbol: fixtures.DEFAULT_TX_FEE_SYMBOL,
      },
      status: txStatus,
      timestamp: fixtures.DEFAULT_TX_TIMESTAMP,
      tokenSymbol: fixtures.DEFAULT_TX_SYMBOL,
      transactionId: txid,
    },
    wallet: {
      depositAddress: "unknown",
      walletType: WalletType.SPOT,
    },
  },
  to: {
    account: {
      accountId: `${exchangeId}-1`,
      exchangeId,
    },
    wallet: {
      walletType: WalletType.SPOT,
      depositAddress: "unknown",
    },
    transaction: {
      amount: fixtures.DEFAULT_TX_AMOUNT_2,
      fee: {
        amount: fixtures.DEFAULT_TX_FEE,
        tokenSymbol: fixtures.DEFAULT_TX_FEE_SYMBOL,
      },
      status: txStatus,
      timestamp: fixtures.DEFAULT_TX_TIMESTAMP,
      tokenSymbol: fixtures.DEFAULT_TX_SYMBOL_2,
      transactionId: txid,
    },
  },
  type: "order",
});

export const createMockedDeposit = (
  exchangeId = fixtures.DEFAULT_EXCHANGE_ID,
  txid = fixtures.DEFAULT_TX_ID,
  txHash = fixtures.DEFAULT_TX_HASH,
): Transaction<DefiInfoTx, CefiInfoTx> => ({
  from: {
    account: {
      address: "unknown",
      network: "unknown",
    },
    transaction: {
      transactionHash: txHash,
      timestamp: fixtures.DEFAULT_TX_TIMESTAMP,
      fee: {
        amount: 0,
        tokenSymbol: "BTC",
      },
      status: TxStatus.OK,
      tokens: [
        {
          amount: fixtures.DEFAULT_TX_AMOUNT_2,
          tokenSymbol: "BTC",
          address: "unknown",
        },
      ],
    },
  },
  to: {
    account: {
      exchangeId,
      accountId: `${exchangeId}-1`,
    },
    wallet: {
      depositAddress: "unknown",
      walletType: WalletType.SPOT,
    },
    transaction: {
      transactionId: txid,
      amount: fixtures.DEFAULT_TX_AMOUNT_2,
      tokenSymbol: "BTC",
      fee: {
        amount: 0,
        tokenSymbol: "BTC",
      },
      status: TxStatus.OK,
      timestamp: fixtures.DEFAULT_TX_TIMESTAMP,
    },
  },
  type: "deposit",
});

export const createMockedWithdrawal = (
  exchangeId = fixtures.DEFAULT_EXCHANGE_ID,
  txid = fixtures.DEFAULT_TX_ID,
  txStatus = fixtures.DEFAULT_TX_STATUS,
): Transaction<CefiInfoTx, DefiInfoTx> => ({
  from: {
    account: {
      exchangeId,
      accountId: `${exchangeId}-1`,
    },
    wallet: {
      depositAddress: "unknown",
      walletType: WalletType.SPOT,
    },
    transaction: {
      transactionId: txid,
      amount: fixtures.DEFAULT_TX_AMOUNT,
      tokenSymbol: fixtures.DEFAULT_TX_SYMBOL,
      fee: {
        amount: fixtures.DEFAULT_TX_FEE,
        tokenSymbol: fixtures.DEFAULT_TX_FEE_SYMBOL,
      },
      status: txStatus,
      timestamp: fixtures.DEFAULT_TX_TIMESTAMP,
    },
  },
  to: {
    account: {
      address: fixtures.DEFAULT_TX_ADDRESS,
      network: fixtures.DEFAULT_TX_NETWORK,
    },
    transaction: {
      transactionHash: fixtures.DEFAULT_TX_HASH,
      timestamp: fixtures.DEFAULT_TX_TIMESTAMP,
      fee: {
        amount: fixtures.DEFAULT_TX_FEE,
        tokenSymbol: fixtures.DEFAULT_TX_FEE_SYMBOL,
      },
      status: txStatus,
      tokens: [
        {
          amount: fixtures.DEFAULT_TX_AMOUNT,
          tokenSymbol: fixtures.DEFAULT_TX_SYMBOL,
          address: "unknown", // TODO to remove this field (it's a token smart contract address, whichi should be in the token metadata list)
        },
      ],
    },
  },
  type: "withdrawal",
});

export const createMockedOrder = (id = fixtures.DEFAULT_TX_ID, status = fixtures.DEFAULT_ORDER_STATUS): Order => ({
  id,
  timestamp: fixtures.DEFAULT_TX_TIMESTAMP,
  status: status,
  pairSymbol: fixtures.PAIR_SYMBOL,
  type: OrderType.MARKET,
  side: "buy",
  price: fixtures.PRICE,
  amount: fixtures.DEFAULT_TX_AMOUNT_2,
  filled: fixtures.DEFAULT_TX_AMOUNT_2,
  fee: {
    amount: fixtures.DEFAULT_TX_FEE,
    tokenSymbol: "BTC",
  },
});
